export enum GroupBy {
  Site = "SITE",
  Rule = "RULE",
  Priority = "PRIORITY",
  Category = "CATEGORY",
}

export enum SortBy {
  Hits = "HITS",
  Equips = "EQUIPS",
  InsightsDesc = "INSIGHTS_DESC",
  InsightsAsc = "INSIGHTS_ASC",
  AlphaAsc = "ALPHA_ASC",
  AlphaDesc = "ALPHA_DESC",
  // TODO: Unassociated
}

export interface SortOrGroup {
  /** Should be an enum of the option being configured */
  value: string | number;
}

export interface DropdownOption extends SortOrGroup {
  label(i18n: any): string;
  sub?(i18n: any): string;
}

/** The sort direction constants supported in the UI */
export type SortDirection = "asc" | "desc";

export enum TimeRange {
  Last24Hours = 1,
  Last3Days = 3,
  Last7Days = 7,
  Last30Days = 30,
}

/** Possible categories that can be assigned to rules */
export enum Category {
  Connectivity = "connectivity",
  Metering = "metering",
  Performance = "performance",
  Comfort = "comfort",
  All = "all",
  Other = "null",
}

export type SearchCB = (value: {
  query: string;
  filtered: Insite.Insights.ComposedOccurrence[];
}) => void;

export type OnSearch = (
  setFiltered: React.Dispatch<
    React.SetStateAction<Insite.Insights.ComposedOccurrence[]>
  >,
  setQuery: (query: string) => void
) => SearchCB;
